import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PROVIDER_ID_LOADING = 'GET_PROVIDER_ID_LOADING';
export const GET_PROVIDER_ID_SUCCESS = 'GET_PROVIDER_ID_SUCCESS';
export const GET_PROVIDER_ID_REJECT = 'GET_PROVIDER_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getProviderIdLoading = () => ({ type: GET_PROVIDER_ID_LOADING });
export const getProviderIdSuccess = (payload) => ({ type: GET_PROVIDER_ID_SUCCESS, payload });
export const getProviderIdReject = (payload) => ({ type: GET_PROVIDER_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getProviderIdRequest = async ({ id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { Id: id },
    }, getState);
    return request(`/Providers/web/GetProvidersById`, options);
};